module.exports = __webpack_public_path__ + "img/bg-32.888387ea.png";